export enum GenderType {
  ExcludeBoth = -3,
  ExcludeFemale = -2,
  ExcludeMale = -1,
  IncludeMale = 1,
  IncludeFemale = 2,
  IncludeBoth = 3,
}
